import { render, staticRenderFns } from "./MenuFontStyle.vue?vue&type=template&id=1dbce056&scoped=true"
import script from "./MenuFontStyle.vue?vue&type=script&lang=js"
export * from "./MenuFontStyle.vue?vue&type=script&lang=js"
import style0 from "./MenuFontStyle.vue?vue&type=style&index=0&id=1dbce056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbce056",
  null
  
)

export default component.exports